export interface WeatherForecast {
  summary: string;
  temperature: number | null;
}

/** Fetch a simple text forecast from Open-Meteo (free, no API key). */
export async function fetchWeatherForecast(
  eventDateIso: string,
  location?: string | null
): Promise<WeatherForecast | null> {
  try {
    let lat = -34.6;
    let lon = -58.38;

    if (location?.trim()) {
      const geoRes = await fetch(
        `https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(location)}&count=1`
      );
      const geo = await geoRes.json();
      if (geo.results?.[0]) {
        lat = geo.results[0].latitude;
        lon = geo.results[0].longitude;
      }
    }

    const eventDate = new Date(eventDateIso);
    const dateStr = eventDate.toISOString().slice(0, 10);

    const wxRes = await fetch(
      `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&hourly=temperature_2m,weathercode&timezone=auto&start_date=${dateStr}&end_date=${dateStr}`
    );
    const wx = await wxRes.json();
    const hour = eventDate.getHours();
    const temp = wx.hourly?.temperature_2m?.[hour] ?? wx.hourly?.temperature_2m?.[0];
    const code = wx.hourly?.weathercode?.[hour] ?? wx.hourly?.weathercode?.[0];

    return {
      summary: weatherCodeToText(code),
      temperature: temp != null ? Math.round(temp) : null,
    };
  } catch {
    return null;
  }
}

function weatherCodeToText(code: number | undefined): string {
  if (code == null) return "—";
  if (code === 0) return "Despejado";
  if (code <= 3) return "Parcialmente nublado";
  if (code <= 48) return "Niebla";
  if (code <= 67) return "Lluvia";
  if (code <= 77) return "Nieve";
  if (code <= 82) return "Chaparrones";
  return "Tormenta";
}
